module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAaBAMAAAAH7hLZAAAALVBMVEVHcEzd3d3c3Nzd3d3e3t7c3Nzc3Nzc3Nzc3Nzd3d3d3d3c3Nzc3Nzc3Nzc3NwzR2lPAAAADnRSTlMA4/ggDqW4yn0yklnYQmlotmgAAADYSURBVCjPY+BM0lnJgA5mFYpOYJj07t27ajSJ7UAxTYY8IPlO6gqSOGcjSOgZgx6IevcoAybHuVUOIgKVAQKx7pvGc3eEw/iPGOLeYQdPGQxxyAgzMMthlXhowIBDkzDQMcznsEi8MQC50waLzGGwD1jqMCSeO0A8544hUwL1NoYmmBYGBjc0mRR4GLLkoUg8c0AELxuKTAJyjMShhBgyYEWSCUCNxnVwiVdoEcwFl1mAnihgml5gJBcOqEwDhgxDE1hCA1OCgRcUG28uYJFh4A5UEt2A4AIAu5dOKvqmh/gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/open.png
// module id = 636
// module chunks = 1